import React from 'react';

export default function ConfirmedHubbyDrafts() {
  const [profiles, setProfiles] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [message, setMessage] = React.useState('');

  const loadProfiles = React.useCallback(async () => {
    setLoading(true);
    setMessage('');
    try {
      const response = await fetch('/api/sirri_api/confirmed_hubby_drafts', {
        credentials: 'include',
      });
      const data = await response.json();
      if (data.responsecode === 200) {
        setProfiles(data.acc || []);
      } else {
        setMessage(data.message || 'Failed to load confirmed hubby drafts.');
      }
    } catch (err) {
      console.error('Failed to load confirmed hubby drafts', err);
      setMessage('Failed to load confirmed hubby drafts.');
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    loadProfiles();
  }, [loadProfiles]);

  return (
    <div className="text-white">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <h1 className="text-2xl font-semibold">Confirmed Hubby Drafts</h1>
        <button
          type="button"
          className="px-4 py-2 rounded-full bg-secondary text-white"
          onClick={loadProfiles}
        >
          Refresh
        </button>
      </div>
      {message ? <p className="mb-4 text-yellow-200">{message}</p> : null}
      {loading ? <p>Loading confirmed hubby drafts…</p> : null}
      {!loading && profiles.length === 0 ? (
        <p>No confirmed hubby drafts found.</p>
      ) : null}
      <div className="space-y-4">
        {profiles.map((profile) => (
          <div
            key={profile.__id || profile.EMAIL || profile.fullname1}
            className="bg-primary p-4 rounded-lg"
          >
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div>
                <h2 className="text-xl font-semibold">
                  {profile.fullname1 || 'Unnamed'}
                </h2>
                <p className="text-sm text-gray-200">
                  {profile.age1 ? `Age ${profile.age1}` : null}
                  {profile.country1 ? ` • ${profile.country1}` : null}
                </p>
              </div>
              {profile.EMAIL ? (
                <span className="text-xs uppercase tracking-wide text-gray-100">
                  {profile.EMAIL}
                </span>
              ) : null}
            </div>
            <div className="mt-3">
              <p className="text-sm text-gray-200">
                <span className="font-semibold">Woman Profile:</span>{' '}
                {profile.womansprofile}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
